import { history } from '@/client/services/router/request/history';

type ElementOrSelector = HTMLElement | string;

export const deepContains = (parents: ElementOrSelector | ElementOrSelector[], children: HTMLElement): boolean => {
    if (!Array.isArray(parents)) parents = [parents];

    let node: HTMLElement | null = children;
    while (node) {
        for (const parent of parents) {
            if (node === parent || (typeof parent === 'string' && node.matches && node.matches(parent))) return true;
        }

        node = node.parentNode as HTMLElement | null;
    }

    return false;
};

export const blurable = (...args: [HTMLElement, Function][]) => {
    if (!history) return;

    const blur = (e: MouseEvent) => {
        if (e.target === null) return;

        for (const [refElement, hide] of args) {
            if (!deepContains([refElement], e.target as HTMLElement)) hide();
        }
    };

    window.addEventListener('mousedown', blur);

    const unlisten = history.listen(() => {
        for (const [, hide] of args) hide();
    });

    return () => {
        window.removeEventListener('mousedown', blur);
        unlisten();
    };
};

export const focusContent = (container: HTMLElement) => {
    const toFocus =
        container.querySelector<HTMLInputElement | HTMLTextAreaElement | HTMLButtonElement>(
            'input, textarea, button.btn.primary, footer > button.btn',
        ) || container;

    toFocus?.focus();
};
